export const getStateValue = (state, key) => {
    switch (key) {
        case "accessToken":
            return state.auth?.oidc?.user?.access_token;
        case "connectionId":
            return state.otherModulesData?.operationNotificationConnectionId;
        default:
            return null;
    }
};
